import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';



const ModalUploadRentalsExpenseForm = () => {
    const server_app_api_php = window.SERVER_APP_API_PHP;
    const [companyID] = useState(1); // Replace with actual companyID
    const [location] = useState(1);
  const [businessLocations, setBusinessLocations] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [businessLocationID, setBusinessLocationID] = useState('');
  const [expense, setExpense] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [amount, setAmount] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [years, setYears] = useState([]);

  let business_locationIDMain = localStorage.getItem('business_locationIDMain')
  if(business_locationIDMain === null){
    business_locationIDMain = '';
  }
  let userCompanyID = localStorage.getItem('companyID')
if(userCompanyID === 'Admin'){
 userCompanyID = 1;
}

console.log('Location =', business_locationIDMain);
console.log('Company = ', window.userCompanyID);

  useEffect(() => {
    // Create formData object
    const formData = new FormData();
    formData.append("apiType", 'getBusinessLocationHousesOnUploadForm');
    formData.append("companyID", userCompanyID);
    formData.append("location", business_locationIDMain);
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        //console.log('what am receiving from server = ', response.data)
        setBusinessLocations(response.data);
      })
      .catch(error => {
        //alert("There was an error fetching the Business Locations!", error);
      });
    }, []);

    useEffect(() => {
        // Create formData object
        const formData = new FormData();
        formData.append("apiType", 'getBusinessLocationExpensesOnUploadForm');
        formData.append("companyID", userCompanyID);
        formData.append("location", business_locationIDMain);
        // Fetch plot options from the backend using POST method
        axios.post(`${server_app_api_php}/server/index.php`, formData)
          .then(response => {
            setExpenses(response.data);
          })
          .catch(error => {
            //alert("There was an error fetching the Business Location Expenses!", error);
          });

          const currentYear = new Date().getFullYear();
          const futureYears = Array.from({ length: 2100 - currentYear }, (_, i) => currentYear + i);
          setYears(futureYears);
        }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'business_locationIDExpenseRentals':
        setBusinessLocationID(value);
        break;
      case 'expenseRentals':
        setExpense(value);
        break;
      case 'monthExpenseRentals':
        setMonth(value);
        break;
      case 'yearExpenseRentals':
        setYear(value);
        break;
      case 'expenseAmountRentals':
        setAmount(value);
        break;
      default:
        break;
    }
  };

  /*
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsButtonDisabled(true);

    if (businessLocationID && expense && month && year && amount) {
      const formData = {
        business_locationIDExpenseRentals: businessLocationID,
        companyIDExpenseRentals: window.userCompanyID,
        userIDRentalExpenses: window.userID,
        expenseRentals: expense,
        monthExpenseRentals: month,
        yearExpenseRentals: year,
        expenseAmountRentals: amount,
        apiType: 'uploadExpensesRentals',
      };

      axios.post(`${server_app_api_php}/upload.php`, formData)
        .then(response => {
          alert(response.data);
          // Reset form fields
          setBusinessLocationID('');
          setExpense('');
          setMonth('');
          setYear('');
          setAmount('');
        })
        .catch(error => {
          alert('There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team');
          console.error('There was an error!', error);
        })
        .finally(() => {
          setIsButtonDisabled(false);
        });
    } else {
      alert('Please fill all fields.');
      setIsButtonDisabled(false);
    }
  };
  */

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsButtonDisabled(true);

    if (businessLocationID && expense && month && year && amount) {
      // Create a new FormData object
      const formData = new FormData();
      formData.append('business_locationIDExpenseRentals', businessLocationID);
      formData.append('companyIDExpenseRentals', window.userCompanyID);
      formData.append('userIDRentalExpenses', window.userID);
      formData.append('expenseRentals', expense);
      formData.append('monthExpenseRentals', month);
      formData.append('yearExpenseRentals', year);
      formData.append('expenseAmountRentals', amount);
      formData.append('apiType', 'uploadExpensesRentals');

      // Send the FormData object using Axios
      axios.post(`${server_app_api_php}/upload.php`, formData)
        .then(response => {
          alert(response.data);
          // Reset form fields
          setBusinessLocationID('');
          setExpense('');
          setMonth('');
          setYear('');
          setAmount('');
        })
        .catch(error => {
          alert('There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team');
          console.error('There was an error!', error);
        })
        .finally(() => {
          setIsButtonDisabled(false);
        });
    } else {
      alert('Please fill all fields.');
      setIsButtonDisabled(false);
    }
  };

  
  return (
    <>
    <Header />
    <hr />
    <div className="mt-5" id="modalUploadRentalsExpenseForm" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <p className="heading lead">Register Rentals Expenses</p>
      
          </div>
          <div className="modal-body">
          {business_locationIDMain && (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="business_locationIDExpenseRentals" name="business_locationIDExpenseRentals" value={businessLocationID} onChange={handleInputChange} required>
                    <option value="">Choose Business Location..</option>
                    {businessLocations.map(location => (
                      <option key={location.businessLocationID} value={location.businessLocationID}>
                        {location.businessLocationName}
                      </option>
                    ))}
                  </select>
                </div>
                { businessLocationID != "" ? (
                  <>
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="expenseRentals" name="expenseRentals" value={expense} onChange={handleInputChange} required>
                    <option value="">Choose Expense..</option>
                    {expenses.map(exp => (
                      <option key={exp.expensesID} value={exp.expensesID}>
                        {exp.expenses}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="monthExpenseRentals" name="monthExpenseRentals" value={month} onChange={handleInputChange} required>
                    <option value="">Choose Month..</option>
                    <option value="January">January</option>
                    <option value="February">February</option>
                    <option value="March">March</option>
                    <option value="April">April</option>
                    <option value="May">May</option>
                    <option value="June">June</option>
                    <option value="July">July</option>
                    <option value="August">August</option>
                    <option value="September">September</option>
                    <option value="October">October</option>
                    <option value="November">November</option>
                    <option value="December">December</option>
                  </select>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="yearExpenseRentals" name="yearExpenseRentals" value={year} onChange={handleInputChange} required>
                    <option value="">Choose Year..</option>
                    {years.map(y => (
                      <option key={y} value={y}>{y}</option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="expenseAmountRentals" name="expenseAmountRentals" className="form-control form-control-md" value={amount} onChange={handleInputChange} required />
                    <label htmlFor="expenseAmountRentals">Amount</label>
                  </div>
                </div>
                </>
                ) : (<></>)

          }
                <input type="hidden" id="companyIDExpenseRentals" value={window.userCompanyID} />
                <input type="hidden" id="userIDRentalExpenses" value={window.userID} />
                <div className="text-center mt-0">
                  <button type="submit" className="btn btn-success" id="uploadExpensesRentals" 
                  disabled = {businessLocationID === "" || expense === "" || month === "" || year === "" || amount === ""}
                  >
                    Upload <i className="fas fa-pen-alt ml-1"></i>
                  </button>
                </div>
              </div>
            </form>

        )}
          </div>
          <div className="modal-footer">
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ModalUploadRentalsExpenseForm;
